import { GraduationCap, Quote } from "lucide-react";
import { Reveal } from "../motion/Reveal";
import { COACH_IMG } from "../../data/academyData";

export const CoachBio = () => (
  <section id="coach" data-testid="coach-bio-section" className="relative py-20 md:py-32 bg-[#0A0A0D] border-t border-white/[0.06]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <Reveal>
        <div className="relative">
          <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-rose-600/20 to-amber-500/10 blur-2xl" />
          <div className="relative rounded-3xl overflow-hidden border border-white/10 aspect-[4/5]">
            <img src={COACH_IMG} alt="Aradhya Xenova, Founder of AX Academy and Relationship, Mindset & Intimacy Coach" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-black border border-rose-500/30 rounded-2xl px-6 py-4 hidden sm:block">
            <p className="font-heading text-2xl font-bold text-white">Aradhya Xenova</p>
            <p className="text-xs text-rose-400 font-mono uppercase tracking-wider">Founder, AX Academy</p>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-rose-400 font-semibold mb-4">Meet Your Coach</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold text-white leading-tight">
          The Woman Changing How India Talks About Sex & Love.
        </h2>
        <p className="mt-6 text-zinc-400 text-lg leading-relaxed">
          Aradhya Xenova is India's boldest Relationship, Mindset & Intimacy Coach — on a fearless mission to end the shame, silence & misinformation around sex and love in India.
        </p>
        <div className="mt-6 flex items-start gap-3 text-zinc-300">
          <GraduationCap size={20} className="text-amber-400 mt-1 shrink-0" />
          <p>Bachelor's degree in Clinical Sexology, currently pursuing her Master's in France — combining academic expertise with deep cultural understanding of the Indian mindset.</p>
        </div>
        <p className="mt-4 text-zinc-400 leading-relaxed">
          She has helped hundreds of Indian adults — single and partnered — rediscover pleasure, rebuild intimacy, reclaim confidence & transform their relationships from the inside out.
        </p>
        <div className="mt-8 border-l-2 border-amber-500 pl-6">
          <Quote size={20} className="text-amber-500 mb-2" />
          <p className="font-heading text-xl text-white italic leading-relaxed">
            "Sex is not a taboo. It is a human need. And every Indian adult — single or partnered — deserves honest, shame-free education. That is why AX Academy exists."
          </p>
          <p className="mt-3 text-sm text-zinc-500 font-mono">— Aradhya Xenova, Founder</p>
        </div>
      </Reveal>
    </div>
  </section>
);
